// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkBlockEditor_root__xVrVe","hint":"LinkBlockEditor_hint__LS04k"};